export default __webpack_public_path__ + "static/media/underConstructionImage.fc39e546.png";